import React from 'react';
import Illustration from './illustrations/Illustration';
import { Col } from '@paypalcorp/pp-react';

function PendingWarning() {
  return (
    <Col xs={12} className="ppvx_d-flex ppvx_justify-content-center">
      <Illustration type="warning" />
    </Col>
  );
}

export default PendingWarning;
